import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const setSelectedBusinessUnit = (businessUnit: string): Action<FirmsActions> => {
  return createAction(FirmsActions.setSelectedBusinessUnit, businessUnit);
};
